import { render, staticRenderFns } from "./onion_skin_viewer.vue?vue&type=template&id=60d13f7f"
import script from "./onion_skin_viewer.vue?vue&type=script&lang=js"
export * from "./onion_skin_viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports